module.exports = "<div id=\"mainFrame\" class=\"container-fluid\">\n\n    <h3>Dernières news</h3>\n\n    <darkadia-news-carousel></darkadia-news-carousel>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main